class Panels {
    panelElm:JQuery = null;
    panels = {};
    constructor(selector) {
        let that = this;
        this.panelElm = jQuery(selector);
        this.panelElm.children('.panel').each(function() {
            that.panels[this.dataset.name] = jQuery(this);
        });
    }
    get activePanel() {
        let result = document.body.dataset.proplusActivePanel;
        if (!result)
            result = null;
        return result;
    }
    set activePanel(value) {
        if (!value)
            delete document.body.dataset.proplusActivePanel;
        else
            document.body.dataset.proplusActivePanel = value;
    }
    toggle(name) {
        if (this.activePanel === name) {
            this.close();
        } else {
            this.open(name);
        }
    }
    open(name) {
        this.close();
        if (!this.panelExists(name))
            return false;
        
        this.activePanel = name;
        this.panels[name].addClass('active');   
    }
    close() {
        let name = this.activePanel;
        if (!this.panelExists(name)) {
            this.activePanel = null;
            return false;
        }
        
        this.panels[name].removeClass('active');
        this.activePanel = null;
    }
    panelExists(name) {
        return !!this.panels[name];
    }
}
jQuery(function($) {
    let panels = new Panels('#proplus-panels');
    window['p'] = panels;
    let toggleElms = $(".proplus-toggle-panel");
    toggleElms.on('click', function(e) {
        e.preventDefault();
        panels.toggle(this.dataset.panelName)
    });
    panels.panelElm.on('click', function(e) {if (e.target === this) panels.close()});

    panels.panelElm.find('.panel[data-content-from]').each(function() {
        let selector = this.dataset.contentFrom;
        let panelName = this.dataset.name;
        let panelInner = $(this).find(".inner");
        let contentElms = $(selector);
        
        contentElms.clone(true,true).appendTo(panelInner);
        panelInner.find('[id]').each(function() {
            this.id = panelName + "-" + this.id;
        });
    });
    panels.panelElm.find('.panel').each(function() {
        let text = $(this).text().trim();
        if (!text) {
            this.classList.add('empty');
        }

    });
    panels.panelElm.find('.panel.empty').each(function() {
        let toggleElm = toggleElms.filter('[data-panel-name="' + this.dataset.name + '"]');
        toggleElm.addClass('panel-empty');
    });
});